import { groq } from "next-sanity"

import { groqQueryOptions } from "@/graphql/schemas/shared/utils/groqQueryOptions"
import { AppSettings } from "@/settings"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { articleGroupProjection } from "../sanity/articleGroup.projection"

export const queryArticleGroups = {
  async articleGroups(parent, args, context, info) {
    let { offset, limit, sort, lang = AppSettings.defaultLocale(), cdn = true, sortWithinLimits } = args

    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.ARTICLE_GROUPS,
      operation: Operations.READ,
    })

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    const { pipesAndLimits, draftsFilter } = groqQueryOptions({
      sort,
      offset,
      limit,
      sortWithinLimits,
      includeDrafts: true,
    })

    let articleGroups
    articleGroups = await client.fetch(
      groq`{
        "total": count(*[_type=="articleGroup"]),
        "items": *[_type=="articleGroup"  ${draftsFilter}]${pipesAndLimits} {
            ...,
           ${articleGroupProjection()}
        } 
      }`,
    )

    if (!articleGroups)
      articleGroups = {
        offset,
        limit,
        count: 0,
        total: 0,
        items: [],
      }

    articleGroups = {
      ...articleGroups,
      offset,
      limit,
      count: articleGroups.items.length,
    }

    return articleGroups
  },
}
